import React, { FC, ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/rootReducer';
import { getADATitle } from '../../util/Ada';
import { fullDateFormat } from '../../util/date';
import { LOC } from '../../util/strings';
import ParseHtml from '../common/ParseHtml';
import withLocalization from '../hoc/withLocalization';
import PackagePrice from './PackagePriceInformation/PackagePrice';
import './PackageSummary.scss';

const PackageSummary: FC<any> = (props: any): ReactElement => {
  const { localize } = props;
  const offerDetails = useSelector((state: RootState) => state.offerDetails);
  const selectedRoom = offerDetails.selectedRoomType;
  const availabilityDates = useSelector((state: RootState) => state.availabilityDates);
  const selectedDate = availabilityDates.finalSelectedDate;
  const offer = offerDetails.currentOffer;
  const searchParameter = offerDetails.searchParameter;
  const openDateSelector = availabilityDates.openDateSelector;
  const hearingADACode = availabilityDates.hearingADACode;
  const selectedADARoomCode = availabilityDates?.roomADACode ? availabilityDates.roomADACode : '';
  const extraNights = availabilityDates.finalSelectedExtraNights ? availabilityDates.finalSelectedExtraNights : 0;
  const calculatedNumberOfNights =
    selectedRoom && selectedRoom.numberOfNights ? parseInt(selectedRoom.numberOfNights, 10) : 0;

  const premiums =
    offer && offer.premiums
      ? offer?.premiums
          .filter((x) => x !== null)
          .join(', ')
          .trim()
      : '';
  return (
    <div>
      <div className="packageSummaryDisplay">
        <h5 className="h3Mont upperCase">
          {localize('preview-sales-engine.static-content.copy.package-summary-component.title')}
        </h5>
        <div className="headingPadding">
          {searchParameter.mode === LOC ? (
            <p>
              <span className="bolderText">
                {localize('preview-sales-engine.static-content.copy.package-summary-component.package-code-label')}{' '}
              </span>
              <span>{offerDetails?.locDescription}</span>
            </p>
          ) : (
            <p>
              <span className="bolderText">
                {localize('preview-sales-engine.static-content.copy.package-summary-component.pin-label')}{' '}
              </span>
              <span>{searchParameter.pin}</span>
            </p>
          )}
          {offerDetails.alternateLOC ? (
            <p>
              <span className="bolderText">
                {localize('preview-sales-engine.static-content.copy.Labels.labels#alternate-loc')} :
              </span>
              <span>{offerDetails.alternateLOCDescription}</span>
            </p>
          ) : (
            <></>
          )}
        </div>
        <div className="headingPadding">
          <p className="bolderText upperCase">
            {localize('preview-sales-engine.static-content.copy.package-summary-component.package-details-header')}
          </p>
          <p>
            <span className="bolderText">
              {localize('preview-sales-engine.static-content.copy.package-summary-component.resort-label')}{' '}
            </span>
            <span>{selectedRoom?.property?.name}</span>
          </p>
          <p>
            <span className="bolderText">
              {localize('preview-sales-engine.static-content.copy.package-summary-component.unit-type-label')}{' '}
            </span>
            <span>{selectedRoom?.roomTypeDescription}</span>
          </p>
          {!openDateSelector && selectedDate && selectedDate.checkInDate ? (
            <p>
              <span className="bolderText">
                {localize('preview-sales-engine.static-content.copy.package-summary-component.check-in-label')}
              </span>
              <span> {fullDateFormat(selectedDate.checkInDate)}</span>
            </p>
          ) : (
            <></>
          )}
          {!openDateSelector && selectedDate && selectedDate.checkOutDate ? (
            <p>
              <span className="bolderText">
                {localize('preview-sales-engine.static-content.copy.package-summary-component.check-out-label')}{' '}
              </span>
              <span>{fullDateFormat(selectedDate.checkOutDate)}</span>
            </p>
          ) : (
            <></>
          )}
          <p>
            <span className="bolderText">
              {localize('preview-sales-engine.static-content.copy.package-summary-component.nights-label')}{' '}
            </span>
            <span>{calculatedNumberOfNights}</span>
          </p>
          {!openDateSelector && extraNights > 0 ? (
            <p>
              <span className="bolderText">
                {localize('preview-sales-engine.static-content.copy.Labels.labels#extra-nights')}{' '}
              </span>
              <span>{extraNights}</span>
            </p>
          ) : (
            <></>
          )}
          <p>
            <span className="bolderText">
              {localize(
                'preview-sales-engine.static-content.copy.package-summary-component.max-number-of-guests-label',
              )}{' '}
            </span>
            <span>{selectedRoom?.sleepCapacity}</span>
          </p>
          {(selectedADARoomCode || hearingADACode) && !openDateSelector ? (
            <p>
              <span className="bolderText">
                {localize(
                  'preview-sales-engine.static-content.copy.package-summary-component.accessibility-selections',
                )}{' '}
              </span>
              <span>
                {selectedADARoomCode ? localize(getADATitle(selectedADARoomCode)) : ''}
                {hearingADACode && selectedADARoomCode ? ', ' : ''}
                {hearingADACode ? localize('preview-sales-engine.static-content.copy.ADA.hearing') : ''}
              </span>
            </p>
          ) : (
            <></>
          )}
        </div>
        <div className="headingPadding">
          {premiums && (
            <p>
              <span className="bolderText">
                {localize('preview-sales-engine.static-content.copy.package-summary-component.tour-gift-label')}{' '}
              </span>
              <>
                <ParseHtml
                  htmlInput={`${localize('preview-sales-engine.static-content.copy.prospects.plustext')} ${premiums}`}
                ></ParseHtml>
              </>
            </p>
          )}

          <PackagePrice />
        </div>
      </div>
    </div>
  );
};

export default withLocalization(PackageSummary);
